import {Grid} from "@mui/system";
import {MenuItem, TextField, Typography} from "@mui/material";
import {useEffect, useState} from "react";


export const useTallaDesplegable = ({variaciones = []}) => {
    const [seleccionada, setSeleccionada] = useState(
        {}
    )
    const [valor, setValor] = useState('')

    const obtenerNombre = (nombre) => {

        const maxLetra = 20
        if (!nombre) {
            return ''
        }

        if (nombre.length > maxLetra) {
            return nombre.substring(0, maxLetra) + '...'
        } else {
            return nombre
        }
    }

    const obtenerPrimeraDisponible = (arr) => {

        for (let i = 0; i < arr.length; i++) {
            let item = arr[i]
            if (item.cantidad && parseInt(item.cantidad) > 0) {
                return item
            }
        }

        return arr[0]
    }

    useEffect(() => {

        if (variaciones && variaciones.length > 0) {
            let prim = obtenerPrimeraDisponible(variaciones)
            setSeleccionada(prim)
            setValor(prim.nombre)
        }

    }, [variaciones]);
    const Tallas = () => {

        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <TextField
                    size={'small'}
                    sx={{
                        width: 'auto'
                    }}
                    slotProps={{
                        input: {
                            disableUnderline: true,
                            sx: {
                                backgroundColor: '#00000000',
                                mt: 0,
                                pl: 0,
                                '&:hover': {
                                    // backgroundColor: '#00000000'
                                },
                                '&:active': {
                                    //  backgroundColor: '#00000000'
                                }

                            }
                        },
                        inputLabel: {
                            sx: {p: 0}
                        },
                        htmlInput: {
                            sx: {p: 0}
                        }
                    }
                    }

                    select value={valor} onChange={(e) => setValor(e.target.value)}>

                    {variaciones.map((it, index) => {


                        return (
                            <MenuItem value={it.nombre}>

                                <Grid
                                    onClick={() => setSeleccionada(it)}
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'center'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{
                                        transaction: 'all 0.2s ease-in-out',
                                        cursor: 'pointer',
                                        //  border: 1,
                                        p: 0.5,
                                        //  borderColor: seleccionada === it ? theme.palette.primary.main : theme.palette.primary.main + 20,
                                        // maxWidth: it.img ? 200 : 'auto',
                                        minWidth: 20

                                    }}>

                                    {it.img &&
                                        <Grid container size={{xs: 3, sm: 3, md: 3}}
                                              sx={{justifyContent: 'center'}}>
                                            <img src={it.img} width={'90%'} height={'auto'}/>
                                        </Grid>
                                    }

                                    <Grid container size={{xs: 9, sm: 9, md: 9}}
                                          sx={{justifyContent: 'flex-start', pl: it.img ? 1 : 1}}>
                                        <Typography sx={{
                                            textAlign: 'left',
                                            lineHeight: 1.1,
                                            fontSize: it.img ? 14 : 20,
                                            pr: 1,
                                            pl: 2

                                        }}>{obtenerNombre(it.nombre)}</Typography>
                                    </Grid>

                                </Grid>

                            </MenuItem>
                        )


                    })}
                </TextField>


            </Grid>
        )


    }

    return {
        Tallas,
        seleccionada
    }

}

